import { Absence } from "@/api/Absence";
import { Timesheet } from "@/api/Timesheet";
import { ApprovalStatusUtil } from "@/data/ApprovalStatusUtil";

export type ApprovalSummary = {
  timesheetMinutes: number;
  absenceDays: number;
};

export const emptyApprovalSummary = (): ApprovalSummary => ({
  timesheetMinutes: 0,
  absenceDays: 0,
});

export const hasPendingApprovals = (summary?: ApprovalSummary | null): boolean =>
  !!summary && (summary.timesheetMinutes > 0 || summary.absenceDays > 0);

export const summarizeTimesheetPendingMinutes = (entries: Timesheet[]): number =>
  entries
    .filter((entry) => ApprovalStatusUtil.isPending(entry.status))
    .reduce((sum, entry) => sum + entry.minutes, 0);

export const summarizeAbsencePendingDays = (entries: Absence[]): number =>
  entries
    .filter((entry) => ApprovalStatusUtil.isPending(entry.status))
    .reduce((sum, entry) => sum + entry.days, 0);

export const sumApprovalSummaries = (summaries: Iterable<ApprovalSummary>): ApprovalSummary =>
  Array.from(summaries).reduce((total, summary) => ({
    timesheetMinutes: total.timesheetMinutes + summary.timesheetMinutes,
    absenceDays: total.absenceDays + summary.absenceDays,
  }), emptyApprovalSummary());
